import React from 'react'
import "./Quoted.css"

const Quoted = () => {
  return (
    <div>Quoted</div>
  )
}

export default Quoted